"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "corciano": {
    "f5611a98": [{
      "hkey": "fec7843b",
      "slug": "capocavallo-cupe",
      "name": "Capocavallo-Cupe",
      "primary": true,
      "skipSearch": false
    }],
    "capocavallo": [{
      "hkey": "fec7843b",
      "slug": "capocavallo-cupe",
      "name": "Capocavallo-Cupe",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "32a166c7": [{
      "hkey": "c46d9bce",
      "slug": "ellera-chiugiana",
      "name": "Ellera-Chiugiana",
      "primary": true,
      "skipSearch": false
    }],
    "chiugiana": [{
      "hkey": "c46d9bce",
      "slug": "ellera-chiugiana",
      "name": "Ellera-Chiugiana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "corciano"
    }],
    "2d1372a5": [{
      "hkey": "c46d9bce",
      "slug": "ellera-chiugiana",
      "name": "Ellera-Chiugiana",
      "primary": true,
      "skipSearch": false
    }],
    "ellera": [{
      "hkey": "c46d9bce",
      "slug": "ellera-chiugiana",
      "name": "Ellera-Chiugiana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;